
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HomePageEn = lazy(() => import('../pages/home-en/page'));
const EvidencePage = lazy(() => import('../pages/evidence/page'));
const EvidencePageEn = lazy(() => import('../pages/evidence-en/page'));
const PatentPage = lazy(() => import('../pages/patent/page'));
const PatentPageEn = lazy(() => import('../pages/patent-en/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/home-en',
    element: <HomePageEn />,
  },
  {
    path: '/evidence',
    element: <EvidencePage />,
  },
  {
    path: '/evidence-en',
    element: <EvidencePageEn />,
  },
  {
    path: '/patent',
    element: <PatentPage />,
  },
  {
    path: '/patent-en',
    element: <PatentPageEn />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
